import { API } from 'aws-amplify'

const checkUrlIsIframeCompatible = async (environmentId: string, url: string) => {
  await API.post('playlists', `/environments/${environmentId}/url`, { body: { url } })
}

export { checkUrlIsIframeCompatible }
